import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useMaterialUIController, setLayout } from "context";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SemPermissaoPage() {
  const navigate = useNavigate();
  const [, dispatch] = useMaterialUIController();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [dispatch]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={6} px={3} textAlign="center">
        <MDTypography variant="h4" fontWeight="medium" gutterBottom>
          Acesso negado
        </MDTypography>
        <MDTypography variant="body2" color="text" mb={3}>
          Você não tem permissão para acessar esta página. Se acredita que isso
          é um erro, peça ao administrador para revisar suas roles e
          permissões.
        </MDTypography>
        <MDButton
          variant="gradient"
          color="info"
          onClick={() => navigate("/pages/relatorios/estatisticas")}
        >
          Voltar ao início
        </MDButton>
      </MDBox>
    </DashboardLayout>
  );
}
